import { CSSProperties, HTMLAttributes, useCallback } from "react";
import styles from "./ToggleButton.module.css";

export interface ToggleButtonProps {
	state?: {
		disabled?: boolean;
		checked?: boolean;
	};
	hooks?: {
		onChange?: (checked: boolean) => void;
	};
	slots?: {
		button?: Omit<HTMLAttributes<HTMLButtonElement>, "style"> & { style?: CSSProperties };
		knob?: Omit<HTMLAttributes<HTMLDivElement>, "style"> & { style?: CSSProperties };
	};
}

export const ToggleButton = ({ state, hooks, slots }: ToggleButtonProps) => {
	const handleClick = useCallback(() => {
		if (!state?.disabled) {
			hooks?.onChange?.(!state?.checked);
		}
	}, [hooks, state?.checked, state?.disabled]);

	return (
		<button
			type="button"
			aria-pressed={state?.checked}
			disabled={state?.disabled}
			className={styles.toggle}
			onClick={handleClick}
			{...slots?.button}
		>
			<div className={styles.knob} {...slots?.knob} />
		</button>
	);
};
